import {ReportsTableColumn} from './reports-table-column'

export function TableHeaderRow(): JSX.Element {
    return (
        <>
            <ReportsTableColumn gridColumn={2} text="Vessel" colName="vessel" />
            <ReportsTableColumn gridColumn={3} text="Ship Manager" colName="shipManager" />
            <ReportsTableColumn gridColumn={4} text="Report Type" colName="reportType" />
            <ReportsTableColumn gridColumn={6} text="Report ID" colName="reportID" />
            <ReportsTableColumn gridColumn={7} text="Period Start Date" colName="periodStartDate" />
            <ReportsTableColumn gridColumn={8} text="Period End Date" colName="periodEndDate" />
            <ReportsTableColumn gridColumn={9} text="Actions" colName="actions" />
        </>
    )
}
